import { connect } from "react-redux";

import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { withResolvePaths } from "../../withResolvePaths";

import { HeaderPanel } from "./HeaderPanel";

export interface HeaderPanelContainerProps extends FormActionHandlerExecutionInjectableProps {
    bindingPath?: AbsoluteResolvedModelPath;
    onBackButtonClick?: FormActionHandler;
}

const mapDispatchToProps = (dispatch: CandyDispatch, props: HeaderPanelContainerProps) => ({
    onBackButtonClick: async () => {
        await dispatch(async () => {
            if (props.onBackButtonClick != undefined) {
                await props.executeFormActionHandler(props.onBackButtonClick);
            }
        });
    },
});

export const HeaderPanelContainer = withResolvePaths(
    withFormActionHandlerExecution(connect(undefined, mapDispatchToProps)(HeaderPanel))
);
